import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import styles from "./RadioTile.module.scss";
export const RadioTile = ({ readOnly = false, label, description, icon }) => {
    return (_jsxs("div", { className: classnames(styles.radioTileWrapper, {
            [styles.readOnly]: readOnly,
        }), children: [icon && (_jsx("div", { className: styles.radioTileIcon, "aria-hidden": true, children: icon })), _jsxs("div", { className: styles.radioTileText, children: [_jsx("span", { className: styles.radioTileLabel, children: label }), description && _jsx("p", { className: styles.radioTileDescription, children: description })] })] }));
};
//# sourceMappingURL=RadioTile.js.map